<div class="main-card-filters top" [class.filters-show]="areFiltersOpened">
    <div class="card card-filters box-shadow">
        <div class="close-filters">
            <button class="d-block d-sm-none float-right btn btn-link btn-close-filters" (click)="closeFilters()">
                {{ 'components.button.buttonClose' | translate }}
                <em class="icon icon-close"></em>
            </button>
        </div>

        <div class="card-header">
            <div class="row align-items-center">
                <div class="col-auto">
                    <span class="fw-b primary-1">{{ 'filters.title' | translate }}</span>
                </div>
                <div class="col-auto ml-auto">
                    <button class="btn btn-reset btn-sm" (click)="resetFilters()">
                        {{ 'filters.reset' | translate }}
                        <em class="icon icon-close"></em>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="card mt-1 card-filters box-shadow">
        <div class="filter-section__heading">
            {{ 'filters.project.projectTypes' | translate }}
        </div>

        <app-project-participate-filters-dropdown
            (ready)="onUserInvolvedProjectsFilterReady()"
            (selectionChanged)="onParticipationFiltersSelectionChanged()"
            #projectInvolvedUserFilterItems
        ></app-project-participate-filters-dropdown>
    </div>
    <div class="mt-1 card card-filters box-shadow">
        <div id="filters-accordion">
            <div class="filter-section__heading">{{ 'filters.visibility' | translate }}</div>

            <app-organization-filters-checkbox
                (ready)="onOrganizationFilterReady()"
                (selectionChanged)="onOrganizationFiltersSelectionChanged()"
                #organizationFilter
            >
            </app-organization-filters-checkbox>
            <app-communities-filters-dropdown
                (ready)="onCommunitiesFiltersReady()"
                (selectionChanged)="onCommunitiesFiltersSelectionChanged()"
                (checkAllSelectionChanged)="onAllMyCommunitiesSelectionChanged($event)"
                [clearAllSelection]="uncheckAllCommunities"
                projectsDirectory="true"
                #communitiesFilters
            >
            </app-communities-filters-dropdown>
            <app-all-communities-filter-checkbox
                *ngIf="canSeeAllCommunitiesFilter"
                (ready)="onAllCommunitiesFilterReady()"
                (selectionChanged)="onAllCommunitiesFilterSelectionChanged()"
                #allCommunitiesFilter
                [buttonName]="visibleByAllButtonName"
            >
            </app-all-communities-filter-checkbox>
        </div>
    </div>

    <div class="mt-1 card card-filters box-shadow">
        <div class="filter-section__heading">{{ 'filters.skillsInterests.title' | translate }}</div>

        <app-interests-filters-checkbox (ready)="onInterestsFilterReady()" (selectionChanged)="onFiltersSelectionChanged()" #interestsFilter>
        </app-interests-filters-checkbox>

        <app-skills-filters-checkbox (ready)="onSkillsFilterReady()" (selectionChanged)="onFiltersSelectionChanged()" #skillsFilter>
        </app-skills-filters-checkbox>

        <app-organization-skills-filters-checkbox
            *ngIf="canSeeOrganizationSkillsFilter"
            (ready)="onOrganizationSkillsFilterReady()"
            (selectionChanged)="onFiltersSelectionChanged()"
            #organizationSkillsFilter
        >
        </app-organization-skills-filters-checkbox>
    </div>

    <div class="mt-1 card card-filters box-shadow">
        <div class="filter-section__heading">
            {{ 'filters.project.projectDomains' | translate }}
        </div>

        <app-project-types-filters-dropdown
            (ready)="onProjectTypesFiltersReady()"
            (selectionChanged)="onFiltersSelectionChanged()"
            #projectTypesFilters
        >
        </app-project-types-filters-dropdown>
    </div>
</div>
